/**
 * @description: 商品组广告组
 */
import { Button, Input, Table, message, Pagination } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import React, { useCallback, useEffect, useState } from 'react';
import { copy } from '@/common/utils';
import env from '@/env';
import DeleteGroup from './components/group-delete';
import EditGroup from './components/group-edit';
import ShareGroup from './components/group-share';
import { ItemDataOPeration } from './type';
import detailApi from './api';
import AddProductGroup from './components/product-group-add';
import AddAdvertGroup from './components/advert-group-add';
import { MaterialGroupItem } from './interface';
import HandleSource from './components/handle-source';
// import HandleSource from '@/pages/platform-marketing-position/resource-detail/material-play/components/material-group/components/handle-source';
import './index.less';

interface IMaterialProps {
  type: number;
}
const prefix = 'activity-material-list-0331';
const MaterialListGroup = (props: IMaterialProps) => {
  const { type } = props;
  const [materialList, setMaterialList] = useState<MaterialGroupItem[]>([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalType, setModalType] = useState('');
  const [itemData, setItemData] = useState<ItemDataOPeration>({
    id: '',
    name: '',
    num: 0,
    materialId: '',
    sourceType: void 0 || 0,
  });
  const [whiteList, setWhiteList] = useState<string[]>([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [searchStr, setSearchStr] = useState('');

  const queryMaterialList = useCallback(async () => {
    // const param = {
    //     currentPage: page,
    //     pageSize: 10,
    //     searchStr,
    //     reqSource: 1, // 0 默认素材进入; 1 日常活动管理进入
    //     advertGroupIdentify: -1,
    // };
    let param;
    if (type === 1) {
      param = {
        currentPage: page,
        pageSize: 10,
        searchStr,
        reqSource: 1,
        styleId: -1,
      };
    } else {
      param = {
        currentPage: page,
        pageSize: 10,
        searchStr,
        reqSource: 1,
        advertGroupIdentify: -1,
      };
    }
    const res =
      type === 1 ? await detailApi.queryPageProductGroupInfo(param) : await detailApi.queryPageGroupAdvert(param);
    if (res.ret === '0' && res.data?.subCode === '0') {
      setMaterialList([...res?.data?.list]);
      setTotal(res.data?.totalSize || 0);
    } else {
      message.info('获取失败');
    }
  }, [type, page, searchStr]);

  useEffect(() => {
    queryMaterialList();
  }, [queryMaterialList]);

  // 获取权限
  const queryPermissionList = async () => {
    const res = await detailApi.queryMaterialErpWhiteList();
    if (res.ret && res.data?.subCode === '0') {
      setWhiteList([{ ...res.data.whiteList }]);
    } else {
      message.info('获取失败');
    }
  };

  useEffect(() => {
    queryPermissionList();
  }, []);

  const handleCancel = () => {
    setModalVisible(false);
    setModalType('');
  };

  // 分享
  const handleShare = async (data: { accountType: string; accounts: string[]; permissions: string[] }) => {
    const { accountType, accounts, permissions } = data;
    const params = {
      productGroupIds: itemData.materialId,
      erpsType: accountType === 'internal' ? '0' : '1',
      erps: accounts.join(','),
      editAuth: permissions.includes('edit') ? '1' : '0',
      copyAuth: permissions.includes('copy') ? '1' : '0',
      relevanceAuth: permissions.includes('relevance') ? '1' : '0',
    };
    const res = await detailApi.shareProductAuthority(params);
    if (res.ret === '0' && res.data?.subCode === '0') {
      message.info('分享成功');
      handleCancel();
    } else {
      message.info(res.returnMsg || '分享失败');
    }
  };

  // 删除
  const deleteGroup = async () => {
    const res = await detailApi.archiveGroup({ groupId: itemData.materialId, type: type === 1 ? 3 : 2 });
    if (res.ret === '0' && res.data?.subCode === '0') {
      message.info('删除成功');
      handleCancel();
      queryMaterialList();
    } else {
      message.info(res.returnMsg || '删除失败');
    }
  };

  // 上线前替换地址
  const goToDetail = (groupId: string) => {
    window.open(`${env.ACORE_DOMAIN}/material/#/${type === 1 ? 'product' : 'advert'}/${groupId}`);
  };

  // 编辑素材组
  const editGroup = async (data: { name: string; totalNum: number }) => {
    let editApi = type === 1 ? detailApi.editProductGroup : detailApi.editAdvertGroup;
    const res = await editApi({ id: itemData.materialId, ...data });
    if (res.ret === '0' && res.data?.subCode === '0') {
      message.info('编辑成功');
      setModalType('');
      setModalVisible(false);
      queryMaterialList();
    } else {
      message.info(res.msg || '编辑失败');
    }
  };

  const handleCopy = (id: string) => {
    const result = copy(id);
    if (result) {
      message.info('复制成功!');
    }
  };

  const activityCol = [
    {
      title: '素材组名/ID',
      dataIndex: 'id',
      width: 260,
      render: (text: string, record: MaterialGroupItem) => (
        <div className={`${prefix}-materialName`}>
          <span style={{ fontSize: 14 }} className="name" title={record.name}>
            {record.name}
          </span>
          <span className="id">{record.id}</span>
          <span onClick={() => handleCopy(record.id)} style={{ cursor: 'pointer' }}>
            <CopyOutlined />
          </span>
        </div>
      ),
    },
    {
      title: '素材状态',
      dataIndex: 'isLock',
      width: 100,
      render: (text: number) => <span>{text === 0 ? '正常' : '冻结'}</span>,
    },
    {
      title: '素材来源',
      dataIndex: 'materialSource',
      width: 120,
      render: (text: string, record: MaterialGroupItem) => <HandleSource record={record} type={type} />,
    },
    {
      title: '展示数',
      dataIndex: 'totalNum',
      width: 80,
      render: (text: string) => text || '-',
    },
    {
      title: '创建人',
      dataIndex: 'erpNo',
      width: 100,
    },
    {
      title: '操作',
      width: 200,
      render(record: MaterialGroupItem) {
        return (
          <div className="operation">
            <a onClick={() => goToDetail(record.id)}>详情</a>
            <a
              onClick={() => {
                setModalVisible(true);
                setModalType('edit');
                setItemData({
                  id: record.id,
                  name: record.name,
                  num: record.totalNum,
                  materialId: record.id,
                });
              }}
            >
              编辑
            </a>
            <a
              onClick={() => {
                setItemData({
                  id: record.id,
                  name: record.name,
                  num: record.totalNum,
                  materialId: record.id,
                });
                setModalVisible(true);
                setModalType('deleteGroup');
              }}
            >
              删除
            </a>
            <a
              onClick={() => {
                setItemData({
                  id: record.id,
                  name: record.name,
                  num: record.totalNum,
                  materialId: record.id,
                });
                setModalVisible(true);
                setModalType('shareGroup');
              }}
            >
              分享
            </a>
          </div>
        );
      },
    },
  ];

  const createProductGro = async (data: {}) => {
    const params = {
      ...data,
      useBi: '0',
      source: '5',
    };
    const res = await detailApi.createProductGroup(params);
    if (res.ret === '0' && res.data.subCode === '0') {
      message.info('创建成功');
      handleCancel();
      queryMaterialList();
    }
  };

  const createAdvertGro = async (data: {}) => {
    const params = {
      ...data,
      useBi: '0',
    };
    const res = await detailApi.createAdvertGroup(params);
    if (res.ret === '0' && res.data.subCode === '0') {
      message.info('创建成功');
      handleCancel();
      queryMaterialList();
    }
  };

  const handleChangePage = (key: number) => {
    setPage(key);
  };

  const handleOnSearch = (v: string) => {
    setSearchStr(v);
    setPage(1);
  };

  return (
    <div className={`${prefix}-wrapper`}>
      <div className={`${prefix}-search`}>
        <Input.Search
          placeholder={`请输入${type === 1 ? '商品组' : '广告组'}素材组ID、名称、创建人`}
          onSearch={handleOnSearch}
          enterButton="搜索"
          style={{ width: 400 }}
        />
        <Button
          className="newBtn"
          type="primary"
          onClick={() => {
            setModalVisible(true);
            setModalType('add');
          }}
        >
          人工录入
        </Button>
      </div>
      <div className={`${prefix}-table`}>
        <Table columns={activityCol} dataSource={materialList} pagination={false} />
        <div className="footer">
          <Pagination current={page} onChange={handleChangePage} pageSize={10} total={total} showSizeChanger={false} />
        </div>
      </div>
      {modalVisible && modalType === 'edit' && (
        <EditGroup
          type={modalType}
          itemData={itemData}
          visible={modalVisible}
          onCancel={handleCancel}
          handleOk={(data: { name: string; totalNum: number }) => {
            editGroup(data);
          }}
        />
      )}
      {modalVisible && modalType === 'add' && type === 1 && (
        <AddProductGroup
          type={modalType}
          itemData={itemData}
          visible={modalVisible}
          onCancel={handleCancel}
          handleOk={createProductGro}
          whiteList={whiteList}
        />
      )}
      {modalVisible && modalType === 'add' && type === 2 && (
        <AddAdvertGroup
          type={modalType}
          visible={modalVisible}
          onCancel={handleCancel}
          handleOk={createAdvertGro}
          whiteList={whiteList}
        />
      )}
      {modalVisible && modalType === 'deleteGroup' && (
        <DeleteGroup visible={modalVisible} onCancel={handleCancel} handleOk={deleteGroup} />
      )}
      {modalVisible && modalType === 'shareGroup' && (
        <ShareGroup title={itemData.name} visible={modalVisible} onCancel={handleCancel} handleOk={handleShare} />
      )}
    </div>
  );
};

export default MaterialListGroup;
